import { namespaces } from '@common'

export const namespace = namespaces.insurance.value
export const schema = 'productSchema'
export const backendDocType = 'Product'
export const docPrivilege = 'insurance'
